export class SkillAvailability {
    SkillAddress: string;
    Status: string;
    Reason: string;
    WaitTimeSeconds: number;
    CloseInSeconds: number;
    ActiveUsers: number;
    AvailableCapacity: number;
    WithinBusinessHour: boolean;
    CapacityPercentage: number;
}
